// i18n area 'storage' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.hu-HU.meta.json.
import type { enUS } from './storage'

export const huHU: typeof enUS = {
  storage: {
    pools: {
      title: 'Tárolók',
      createTitle: 'Tároló létrehozása',
      path: 'Útvonal',
      pathHint: 'Abszolút útvonal egy engedélyezett root alatt (default /var/lib/tvirt/pools/)',
      shared: 'Megosztott tároló',
      sharedChip: 'megosztott',
      sharedVerifiedChip: 'megosztott · ellenőrzött',
      sharedVerifiedTooltip: 'Ellenőrzött megosztás: a keresztszondák megerősítik, hogy minden tag látja a többiek által írt adatokat.',
      sharedDisputedChip: 'megosztott · NEM ellenőrzött',
      sharedDisputedTooltip: 'NEM ellenőrzött megosztás',
      sharedDisputedPair: '{observer} nem látja a(z) {writer} által írt adatokat',
      sharedHint: 'Hálózati megosztás, minden tagon ugyanarra az útvonalra helyben csatolva — az élő migráció előfeltétele (deklaratív).',
      sharedDanger: 'VESZÉLY — a TVirt HISZ ennek a flagnek: bekapcsolásával minden tag azt feltételezi, hogy UGYANAZOKAT a bájtokat látja ezen az útvonalon. Egy olyan mappán, amely NEM valóban megosztott megosztás (NFS/CIFS/klaszter-fájlrendszer), az eredmény adatsérülés és adatvesztés az első migrációnál vagy az első HA-újraindításnál egy másik csomóponton. Csak akkor kapcsold be, ha az útvonal egy minden csomóponton azonosan csatolt megosztás.',
      type: 'Típus',
      capacity: 'Kapacitás',
      provisioned: 'Lefoglalt',
      provisionedOvercommit: 'A kapacitáson túli potenciális kötelezettség: a thin kötetek {n} GiB-ig nőhetnek.',
      phase: { ready: 'Kész', degraded: 'Degradált', error: 'Hiba' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Konfiguráció',
      tabCapacity: 'Kapacitás és állapot',
      cardIdentity: 'Identitás',
      cardPlacement: 'Elhelyezés',
      cardConnection: 'Kapcsolat',
      usedReal: 'Valós foglaltság',
      capacityUnknown: 'A csomópont még nem jelentette ennek a készletnek a kapacitását — itt nem találunk ki számokat',
      overcommitHint: 'Kötelezettség a kapacitáson túl: thin készleteken jogos, tartsd szemmel a valós foglaltságot',
      supportedContent: 'Támogatott tartalmak',
      content: {
        disks: 'Lemezek',
        catalogFiles: 'Katalógusfájlok',
        backups: 'Backupok',
        appVolumes: 'App-kötetek'
      },
      defaultDiskFormat: 'Alapértelmezett lemezformátum',
      reserveGiB: 'Fenntartott szabad hely (GiB)',
      available: 'Elérhető',
      diskCount: 'Lemezek',
      filesystem: 'Fájlrendszer',
      observedAt: 'Megfigyelve',
      lostAtRow: 'Elveszettnek nyilvánítva',
      sharedProbeRow: 'Megosztás ellenőrzése',
      sharedProbeNodes: 'Szondázott csomópontok',
      reachableFrom: 'Deklarált elérhetőség',
      reachableFromHint: 'A csomópontok, amelyekről ennek a tárolónak elérhetőnek kell lennie. Az a VM, amelynek lemezei, ISO-i vagy metaadatai itt vannak, nem indul és nem migrál a listán kívüli csomópontra. Minden tag előre ki van jelölve: szűkítsd, ahogy akarod. Egy később csatlakozó csomópont kimarad, amíg ide nem veszed fel.',
      reachableFromNone: 'nem deklarált',
      reachableFromTags: 'Elérhetőség címkék szerint',
      reachableFromTagsHint: 'Címke=érték választó (vesszővel elválasztott bejegyzések, ÉS-kapcsolatban): minden tag, amely ezeket a címkéket viseli, elérhetőnek van deklarálva — dinamikusan: egy csomópont felcímkézése beleveszi.',
      reachableFromTagsInvalid: 'Érvénytelen formátum — használj címke=érték párokat, vesszővel elválasztva',
      reachableResolved: 'Feloldott csomópontok: {nodes}',
      reachableDeclaredNotSeen: 'deklarált, de a megosztás-szonda nem látta itt: {nodes}',
      reachableSeenNotDeclared: 'látott, de nem deklarált (a peremen kívül) itt: {nodes}',
      cephCluster: 'Kezelt Ceph-klaszter',
      appGuardTitle: 'Appok által használt tároló',
      appEphemeralGuard: 'ez a tároló az Appok klaszterszintű efemer készlete — előbb cseréld le az Appok oldalról, aztán töröld.',
      appInUseGuard: 'itt élnek appok rootjai/kötetei: {apps} — előbb helyezd át vagy töröld őket.',
      releaseRequiredTitle: "Törlöd a(z) '{name}' storage-ot az image-ei felszabadításával?",
      releaseRequiredBatchTitle: 'Törlöd a kijelölt storage-okat az image-eik felszabadításával?',
      releaseRequiredBody: 'Az image-ek felszabadítása EGYETLEN bájtot sem töröl: a leregisztrálás a lemezen hagyja a namespace-t, az image-ek egyszerűen már nem materializáltak, és a scope-ok minden hivatkozása claimként él tovább — regisztráld újra a poolt, és újra örökbe fogadja őket.',
      releaseConfirm: 'Törlés és az image-ek felszabadítása'
    },
    lost: {
      chip: 'Elveszett',
      action: 'Elveszettnek nyilvánítás',
      confirmTitle: 'A tároló elveszettnek nyilvánítása',
      confirmBody: 'Az operátor nyilatkozata, deklaráltan saját felelősségére: minden, ezen a tárolón vagy az objektumain sorban álló vagy futó feladat SIKERTELEN lesz, a törlések csak nyilvántartásban történnek (semmi munka a fájlrendszeren), az új fizikai munka pedig el lesz utasítva. A bájtokhoz sosem nyúlunk — ha a kötet életre kel, regisztráld újra, és futtass egy szkennelést, hogy mindent újra befogadj.',
      confirmSubmit: 'Elveszettnek nyilvánítás',
      error: 'A nyilatkozat el lett utasítva'
    },
    findings: {
      action: 'Talált objektumok',
      title: 'Talált objektumok',
      empty: 'Nincs talált objektum a tároló névterében',
      loadError: 'A talált objektumok nem tölthetők be',
      actionError: 'A döntés el lett utasítva',
      colKind: 'Típus',
      colObject: 'Objektum',
      colConflict: 'Ütközés',
      namespaceNotice:
        'Ezt a könyvtárat már inicializálta egy másik tároló: az azonosító pecsétet felülírtuk ennek a tárolónak a pecsétjével. A tartalmakhoz NEM nyúltunk — nézd át a lent talált objektumokat, importáld azokat, amelyekre szükséged van, majd zárd be ezt az értesítést.',
      kind: {
        disk: 'Lemez',
        catalogFile: 'Katalógusfájl',
        vmMetadata: 'VM-metaadatok',
        namespace: 'Névtér',
        foreign: 'Idegen',
        volumeGroup: 'Kötetcsoport'
      },
      vgAdopt: {
        action: 'Kötetcsoport örökbefogadása',
        title: 'Kötetcsoport örökbefogadása',
        intro:
          'Ezen az eszközön már van egy TVirt nevű kötetcsoport, de a pecsétje nem nevez meg itt regisztrált storage-ot. Lehet az, amit EZ a fürt korábbi storage-a hagyott a LUN-on — vagy az, amit EGY MÁSIK TVirt fürt hagyott egy gazdát cserélt LUN-on: innen a két eset egyformán néz ki, és ezért senki nem dönt ön helyett.',
        irreversible: 'Nézze meg az eszközt, a pecsétet és a nevet, mielőtt folytatja: az örökbefogadás nem vonható vissza.',
        device: 'Eszköz',
        seal: 'Pecsét',
        sealNone: 'nincs (nincs tvirt.storageId címke)',
        renameTo: 'Átnevezésre kerül erre',
        renameNone: 'Nincs átnevezés: a név már az, amit ez a storage levezet',
        volumesNote:
          'A benne lévő köteteket ez a gesztus NEM fogadja örökbe: a következő vizsgálat egyenként ajánlja fel őket, közönséges talált objektumként.'
      },
      conflictChip: 'Már létező ID',
      dismissedChip: 'Mellőzve',
      adopt: 'Befogadás',
      adoptFileTitle: 'Importálás egy katalógusba',
      adoptFileHint: 'A fájlok csak katalógusokon belül léteznek: válaszd ki a talált fájl célkatalógusát.',
      purge: 'Törlés a lemezről',
      dismiss: 'Mellőzés',
      purgeConfirmTitle: 'Törlés a lemezről',
      purgeConfirmBody: 'A(z) {id} talált bájtjai el lesznek távolítva a tárolóról. A művelet nem visszafordítható.',
      taskStarted: 'Elindítva — háttérfeladatként folytatódik',
      scan: 'A tároló szkennelése',
      scanStarted: 'Szkennelés elindítva…',
      scanDone: 'Szkennelés befejezve — a talált objektumok frissültek'
    },
    reinit: {
      action: 'Inicializálás újrapróbálása'
    },
    wizard: {
      addButton: 'Hozzáadás',
      title: 'Tároló hozzáadása',
      back: 'Vissza',
      continue: 'Folytatás',
      selectHint: 'Válassz ki egy protokollt, hogy lásd, hogyan használja a TVirt.',
      roadmap: 'Roadmap',
      server: 'Szerver',
      export: 'Exportált útvonal',
      share: 'Megosztás',
      username: 'Felhasználónév',
      password: 'Jelszó',
      passwordHint: 'Csak írható: a csatoláshoz használjuk, többé nem jelenik meg.',
      credential: 'Hitelesítő adat',
      credentialManual: 'Kézi megadás',
      credentialHint: 'Egy felhasználónév-és-jelszó típusú keystore-bejegyzés — az alternatíva ahhoz, hogy itt gépeld be.',
      credentialEmpty: 'Nincs felhasználónév-és-jelszó típusú hitelesítő adat a keystore-ban — hozd létre a Rendszer → Hitelesítő adatok alatt, vagy gépeld be a fiókot ide lentre.',
      options: 'Csatolási opciók',
      optionsHint: 'Vesszővel elválasztva, változtatás nélkül átadva a mount -o parancsnak.',
      portal: 'Portal',
      portalHint: 'host[:port] — az alapértelmezett port a 3260.',
      target: 'Target IQN',
      targetHint: 'Az iSCSI-target neve, iqn.-nel kezdődik.',
      lun: 'LUN',
      wholeLunRow: 'A lemezeken: ez a tároló csak a targetet nevezi meg',
      wholeLunHint: 'Ez a tároló csak a targetet nevezi meg: LUN-jai egyenként válnak lemezzé (Lemez létrehozása → teljes LUN átvétele), a targetre semmi sem íródik.',
      lunHint: 'A LUN száma a targeten — kétség esetén 0.',
      chapCredential: 'Hitelesítő adat (CHAP)',
      chapCredentialHint: 'Egy CHAP (iSCSI) típusú keystore-bejegyzés a loginhoz — a titok sosem utazik a tárolóval.',
      chapNone: 'Nincs hitelesítés',
      chapEmpty: 'Nincs CHAP (iSCSI) típusú hitelesítő adat a keystore-ban — hozd létre a Rendszer → Hitelesítő adatok alatt. Nélküle a login hitelesítés nélkül marad.',
      address: 'Cím',
      addressHint: 'Az NVMe/TCP target hostja vagy IP-je (traddr).',
      port: 'Port',
      portHint: 'A target TCP-portja — üresen hagyva 4420.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'A subsystem NQN-je a targeten, nqn.-nel kezdődik.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID a subsystemen belül — kétség esetén 1.',
      dhchapCredential: 'Hitelesítő adat (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Egy DH-HMAC-CHAP (NVMe) típusú keystore-bejegyzés a kapcsolódáshoz — a titok sosem utazik a tárolóval.',
      dhchapNone: 'Nincs hitelesítés',
      dhchapEmpty: 'Nincs DH-HMAC-CHAP (NVMe) típusú hitelesítő adat a keystore-ban — hozd létre a Rendszer → Hitelesítő adatok alatt. Nélküle a kapcsolat hitelesítés nélkül marad.',
      monitors: 'Monitorok',
      monitorsHint: 'A Ceph-monitorok végpontjai, host[:port], vesszővel vagy sortöréssel elválasztva — alapértelmezett port: 6789.',
      pool: 'Készlet',
      poolHint: 'A fogyasztandó RBD-készlet — lemezenként egy RBD-image.',
      fs: 'Fájlrendszer',
      fsHint: 'A CephFS-fájlrendszer neve (mds_namespace a csatoláskor).',
      fsPath: 'Útvonal a fájlrendszeren belül',
      fsPathHint: 'Abszolút útvonal a fájlrendszeren belül, amelyet a tároló csatol — kétség esetén /.',
      cephxCredential: 'Hitelesítő adat (cephx)',
      cephxCredentialHint: 'Egy cephx típusú keystore-bejegyzés: felhasználónév = kliensnév (client.…), titok = a base64 kulcs. Kötelező.',
      cephxNone: 'Nincs cephx hitelesítő adat a keystore-ban — hozz létre egyet (típus: cephx) a Rendszer → Hitelesítő adatok alatt, vagy hagyd, hogy egy kezelt Ceph-klaszter verje a „Felajánlás tárolóként” művelettel.',
      sharedByNature: 'A hálózati tárolók természetüknél fogva megosztottak: minden tag ugyanarra a TVirt által kezelt útvonalra csatolja őket.',
      error: 'A tároló el lett utasítva',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Egyéb',
        legacy: 'Legacy'
      },
      legacyHint: 'Teljes értékűen támogatottak — csak épp új telepítéshez nem ezeket választanánk.',
      proto: {
        // La riga `usage` (Luca 2026-07-24) dice come TVirt usa il protocollo —
        // in primis i contenuti ammessi: dir/nfs/cifs ospitano dischi E immagini
        // ISO/disco e template, i driver a blocchi (iscsi/nvme-tcp/rbd) SOLO
        // dischi.
        dir: {
          name: 'Helyi mappa',
          desc: 'A csomópont egy könyvtára: egyszerű és gyors. Egy csomóponthoz HELYI, hacsak az útvonal nem egy valóban megosztott megosztás — megosztottnak jelölni, amikor nem az, adatokba kerül.',
          usage: 'A TVirt itt tárol VM-lemezeket, ISO-/lemezképeket és sablonokat.'
        },
        nfs: {
          name: 'NFS',
          desc: 'A klaszter által csatolt NFS-export — természeténél fogva megosztott.',
          usage: 'VM-lemezeket, ISO-/lemezképeket és sablonokat tárol.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'A klaszter által csatolt Windows/Samba-megosztás — természeténél fogva megosztott.',
          usage: 'VM-lemezeket, ISO-/lemezképeket és sablonokat tárol.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Távoli fájlrendszer SSH-n keresztül — NAS-export nélkül.',
          usage: 'Roadmapen.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokkos LUN-ok IP-n, felette megosztott LVM-mel.',
          usage: 'Csak lemezek — lemezenként egy thin kötet; ISO-képeket és sablonokat nem tárol.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Elosztott blokkeszközök egy Ceph-klaszteren.',
          usage: 'Csak lemezek — lemezenként egy RBD-image, amelyet a QEMU natívan nyit; ISO-képeket nem tárol.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'A Ceph elosztott fájlrendszere, a kernel által csatolva a klaszteren — shared by nature.',
          usage: 'VM-lemezeket, ISO-/lemezképeket és sablonokat tárol — a dir-család egy Ceph-fájlrendszeren (a cephx hitelesítő adat kötelező).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN-ok FibreChannel fabricen — a klasszikus FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Ugyanaz az SCSI FibreChannelen, az FC-frame-ek Ethernetbe csomagolva.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (teljes LUN-ok)',
          desc: 'Az iSCSI target teljes LUN-ok hordozójaként: minden lemez EGY LUN, nyersen átadva a vendégnek — LVM nélkül.',
          usage: 'Csak lemezek — lemezenként egy teljes LUN, úgy átvéve, ahogy van; a megosztott írású lemezek SAN-otthona.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (teljes namespace-ek)',
          desc: 'Az NVMe alrendszer teljes namespace-ek hordozójaként: minden lemez EGY namespace, nyersen átadva a vendégnek.',
          usage: 'Csak lemezek — lemezenként egy teljes namespace, úgy átvéve, ahogy van; megosztott írás igen, SCSI persistent reservation nem.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Távoli NVMe — semmi SCSI az útvonalban — sima TCP-n, felette megosztott LVM-mel.',
          usage: 'Csak lemezek — lemezenként egy thin kötet; ISO-képeket és sablonokat nem tárol.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Távoli NVMe FibreChannel fabricen.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe azon a FibreChannel fabricen, amelyet az FCoE Etherneten belül szállít — az FCoE és az NVMe/FC rétegek egymásra rakva.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI az adatúttal RDMA-ra helyezve — bármilyen fabric (InfiniBand, iWARP, RoCE). Az NVMe/RDMA meghaladta, de az arrayekben és az ESXi-ben még jelen van.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natív SCSI RDMA-n, az iSER előtti korszak: InfiniBand (fabric-discoveryvel) és RoCE — a régebbi HPC-tárolókban él tovább.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Távoli NVMe bármilyen RDMA-fabricen — InfiniBand, iWARP, RoCE v1 és v2: egyetlen konfiguráció, a csomópont mondja meg, melyikkel rendelkezik.' },
        s3: { name: 'S3', desc: 'S3-kompatibilis objektumtároló — image-ek és biztonsági mentések.' }
      }
    },
    catalogs: {
      title: 'Katalógusok',
      createTitle: 'Katalógus létrehozása',
      editTitle: 'Katalógus szerkesztése',
      docTitle: 'Katalógus',
      notFound: 'Ez a katalógus nem létezik (már?)',
      scopeHint: 'Aki olvassa ezt a scope-ot, látja (és használhatja) a katalógus minden fájlját',
      files: 'Fájlok',
      noFiles: 'Nincs fájl',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT-sablon',
        vmTemplate: 'VM-sablon',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'rendszer',
      systemTooltip: 'Rendszerkatalógus: a platform beépített objektumait tárolja, és nem módosítható'
    },

    // File di catalogo (round K1, inventory v2e/v2g): il catalogo è la casa
    // degli artefatti file del cluster — una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Katalógus',
      kindLabel: 'Típus',
      physicalSize: 'Fizikai méret',
      virtualSize: 'Virtuális méret',

      // Round K3 (#64) + K4 (#65, ova/ovf con la mappatura boot-survival):
      // materializza un file vm-template come VM Template dell'inventario.
      importTemplateAction: 'Importálás VM-sablonként',
      importTemplateLegacy: 'Nincs deklarált formátum — lemezek seedjeként használható, nem importálható',
      importTemplateTitle: 'Importálás VM-sablonként',
      importTemplateSubmit: 'Importálás',
      importTemplateError: 'Az importálás nem sikerült',
      importTemplateHint: 'A .tvtpl csomagból VM-sablon lesz: a manifest befagyasztott hardvere plusz az archívum minden bejegyzéséhez egy lemez, mindegyik az ellenőrzőösszege ellen ellenőrizve. A NIC-ek és a CD/DVD-adathordozók nem részei az archívumnak — az importálás után add hozzá őket.',
      importTemplateQcow2Hint: 'Egy csupasz qcow2-ből EGYlemezes sablon lesz a deklarált default hardverrel: linux profil, UEFI, 2 vCPU, 2048 MiB, boot az egyetlen lemezéről. A deploykor javítsd.',
      importTemplateName: 'A sablon neve',
      importTemplateNameHint: 'Üresen = {name} (-import-<n>, ha foglalt)',
      importTemplateStorage: 'Tároló a lemezeknek',
      importTemplateMetadataStorage: 'Metaadat-tároló',
      importTemplateMetadataHint: 'Egy blokkos tároló nem tárol VM-metaadatokat (firmware, varstore) — válassz egy dir/nfs/cifs típusút.',
      importTemplateStarted: 'Importálás elindítva — a sablon a feladat lezárultakor jelenik meg a Sablonok lapon.',

      // Etichette parlanti al singolare (#86): findings e censimento dicono
      // COSA è il file — il generico 'File di catalogo' resta solo fallback.
      kind: {
        iso: 'ISO-lemezkép',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-sablon',
        'oci-image': 'OCI-image',
        'firmware-ovmf': 'OVMF-firmware'
      },
      title: {
        iso: 'ISO-lemezképek',
        'ct-rootfs': 'CT-sablonok',
        'vm-template': 'VM-sablonok',
        'oci-image': 'OCI-image-ek',
        'firmware-ovmf': 'OVMF-firmware-ek'
      },
      createTitle: {
        iso: 'ISO-lemezkép hozzáadása',
        'ct-rootfs': 'CT-sablon regisztrálása',
        'vm-template': 'VM-sablon hozzáadása',
        'oci-image': 'OCI-image hozzáadása',
        'firmware-ovmf': 'OVMF-firmware hozzáadása'
      },
      formatHint: 'A kiválasztott fájl kiterjesztéséből származtatva — javítsd, ha rosszul tippelt',
      tarballHint: 'Egy rootfs-tarball a szabványos LXC-formátumban (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, vagy egy sima .tar)',
      ociArchiveHint: 'Egy docker-archive / oci-archive tarball (.tar vagy .tar.gz), például docker save-ből',
      uploadResumeHint: 'A feltöltés megszakadt — a fájl feltöltésre vár: küldd el újra ugyanazzal a fájllal a folytatáshoz',
      moveTitle: 'Fájl áthelyezése',
      moveHint: 'Két független dimenzió: a Katalógus a hivatkozást helyezi át (ugyanaz az id, egyetlen bájt sem mozdul, a scope a célkatalógusé lesz); a Tároló az adatokat helyezi át — minden kapcsolt másolat követi, elutasítva, amíg a fájl használatban van. Együtt választva előbb a katalógus, aztán a tároló.',
      moveCatalog: 'Célkatalógus',
      moveCatalogHint: 'Csak a hivatkozás vált otthont: a fájlt csatoló VM-nek látnia kell a célkatalógust',
      keepCurrent: 'Ne változzon',
      rehomed: 'Hivatkozás áthelyezve a kiválasztott katalógusba',
      copyAction: 'Másolás katalógusba…',
      copyTitle: 'Másolás katalógusba',
      copyLinkHint: 'A másolat egy új hivatkozás ugyanazokra az adatokra — a tárolón semmi sem duplikálódik.',
      copyCatalog: 'Célkatalógus',
      copyCatalogHint: 'A másolás a módja annak, ahogy egy fájl katalógusok között utazik',
      sameCatalog: 'Ugyanaz, mint a forrásé',
      sharedObjectHint: 'Ennek a fájlnak az adatain {count} kapcsolt másolat osztozik',
      deleteLastLink: 'Ez az UTOLSÓ hivatkozás erre a tartalomra: az adatok is törlődni fognak a tárolóról.',
      deleteLinkOnly: 'Csak ez a hivatkozás lesz eltávolítva — az adatok megmaradnak, a többi kapcsolt másolatból ({count}) továbbra is elérhetők.',
      noCatalog: 'Nincs egyetlen katalógus sem — hozz létre egyet',
      inlineCatalogName: 'A katalógus neve',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'beépített',
      embeddedStorage: 'A platformba beépítve',
      embeddedNoMove: 'A platform beépített fájlja: nem él egyetlen tárolón sem — klónozd inkább',
      embeddedCopyHint: 'A klón a beépített bájtokat egy valódi tárolóra materializálja: válassz céltárolót és célkatalógust — a másolat egy normál fájl',
      sourceEmbedded: 'A platformba beépítve',
      nodesRow: 'Jelenlét csomópontonként',
      nodesSummary: '{total} csomópontból {present} rendelkezik vele',
      nodePresent: 'megvan',
      nodeMissing: 'hiányzik',
      nodeUnknown: 'még nem jelentett',
      nodesHint: 'Az asset minden csomópont lemezén él (trantor-tvirt-assets csomag): az a csomópont, amelyen nincs meg, nem tud sem ilyen firmware-rel VM-et definiálni, sem Guest Toolst kiszolgálni. A csomópontok közti eltérő verziók gördülő frissítés alatt normálisak.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Letöltés',
      downloadNotReady: 'A tartalom még nem kész — a letöltéshez ready állapotú fájl kell',
      downloadDenied: 'A szerepköröd nem tartalmazza a catalog.download engedélyt — a bájtok letöltése a fájl használatától külön jog',

      // Round #156 (dialog standard): le righe di lettura mancanti del dialog
      // dettagli — i fatti dell'oggetto condiviso, il checksum dichiarato, gli
      // utilizzatori.
      objectRow: 'Tárolóobjektum',
      objectLinksRow: 'Kapcsolt másolatok',
      declaredChecksum: 'Deklarált SHA-256',
      usedByRow: 'Használja',
      usedByVms: 'VM',
      usedByDisks: 'Lemezek',
      transferRow: 'Átvitel',
      storageLockHint: 'Csak az Áthelyezés művelettel változik'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Tartalmak tallózása',
      title: 'A tároló tartalmai',
      hint: 'Csak olvasható számbavétel arról, mi él ezen a tárolón — minden objektum a saját szekciójából kezelhető.',
      empty: 'Nincs regisztrált objektum ezen a tárolón',
      loadError: 'A tartalmak nem tölthetők be',
      colDetail: 'Részlet',
      manage: 'Kezelés a saját szekciójában',
      kind: {
        disk: 'Lemez',
        catalogFile: 'Katalógusfájl',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-metaadatok',
        appRoot: 'App-root',
        appVolume: 'App-kötet'
      }
    },
    inventory: {
      tabCatalogs: 'Katalógusok',
      storage: 'Tároló',
      sizeGib: 'Méret (GiB)',
      format: 'Formátum',
      size: 'Méret',
      sourceType: 'Forrás',
      sourceFile: 'Fájlfeltöltés',
      sourceUrl: 'Letöltés URL-ről',
      file: 'Fájl',
      url: 'URL',
      checksum: 'SHA-256 ellenőrzőösszeg',
      checksumHint: 'Kötelező: a letöltés ez ellen az SHA-256 ellen lesz ellenőrizve',
      verifyChecksum: 'Ellenőrzőösszeg ellenőrzése',
      checksumOffHint: 'A letöltés ellenőrzés nélkül lesz elfogadva — a kiszámított SHA-256 így is rögzítésre kerül',
      uploading: 'Feltöltés…',
      move: {
        action: 'Áthelyezés',
        diskTitle: 'Lemez áthelyezése',
        target: 'Céltároló',
        diskHint: 'A lemez megőrzi az identitását: a bájtok a kiválasztott tárolóra utaznak. Az őt használó VM-nek kikapcsolva kell lennie; meglévő pillanatképekkel az iSCSI oldal elutasítja az áthelyezést.',
        noTargets: 'Nincs kompatibilis céltároló',
        submit: 'Áthelyezés',
        error: 'Az áthelyezés el lett utasítva'
      },
      clone: {
        action: 'Klónozás',
        title: 'Lemez klónozása',
        name: 'A másolat neve',
        storage: 'Céltároló',
        sameStorage: 'Ugyanaz, mint a forrásé',
        linked: 'Linked clone',
        linkedHint: 'Azonnali qcow2-overlay a forráslemezhez láncolva (csak qcow2 forrásoknál). A default a teljes másolat.',
        linkedCrossHint: 'A linked clone a forrás tárolóján marad: válaszd az „Ugyanaz, mint a forrásé” opciót az engedélyezéséhez.',
        submit: 'Klónozás',
        error: 'A klónozás el lett utasítva'
      },
      copy: {
        action: 'Másolás',
        name: 'A másolat neve',
        storage: 'Céltároló',
        sameStorage: 'Ugyanaz, mint a forrásé',
        submit: 'Másolás',
        error: 'A másolás el lett utasítva'
      },
      taskStarted: 'Elindítva — háttérfeladatként folytatódik',
      cephObjects: 'Ugrás az objektum Ceph-részleteihez',
      phase: {
        ready: 'Kész',
        creating: 'Létrehozás alatt',
        'awaiting-upload': 'Feltöltésre vár',
        downloading: 'Letöltés alatt',
        verifying: 'Ellenőrzés alatt',
        deleting: 'Törlés alatt',
        error: 'Hiba',
        'in-use': 'Használatban'
      }
    }
  }
}
